export default __webpack_public_path__ + "static/media/7.088253e8.jpg";